import { useRef, useState } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { validateIntegerField } from "../../../utils/Validation";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import * as React from "react";
import { IAssetsMetadata } from "../../../services/asset/AssetToolingService";

export interface ArtAssetsMetadataEditProps {
  visible: boolean;
  initialData: IAssetsMetadata | undefined;
  onAccept: (data: IAssetsMetadata) => Promise<void>;
  onDismiss: () => void;
}

export const ArtAssetsMetadataEdit = ({ visible, initialData, onAccept, onDismiss }: ArtAssetsMetadataEditProps) => {
  const [loading, setLoading] = useState(false);
  const [lastTextureError, setLastTextureError] = useState<string | undefined>(undefined);

  const refLastTexture = useRef<TextFieldProps>(null);

  const dialogCloseHandler = (event: unknown, reason: string) => {
    if (reason !== "backdropClick") {
      onDismiss();
    }
  };

  const okButtonClickHandler = async () => {
    if (!initialData || !refLastTexture.current) {
      return;
    }

    const lastTexture = validateIntegerField(
      refLastTexture.current.value as unknown as string,
      setLastTextureError,
      0,
      999,
      "lastTexture",
    );

    if (!lastTexture) {
      return;
    }

    onDismiss();
    setLoading(true);
    await onAccept({
      ...initialData,
      lastTexture: lastTexture,
    });
    setLoading(false);
  };

  return (
    <Dialog open={visible} onClose={dialogCloseHandler} fullWidth={true} maxWidth="sm">
      <DialogTitle>Update last texture</DialogTitle>
      <DialogContent>
        <DialogContentText>Update last texture</DialogContentText>
        <DialogContentText>Subcategory: {initialData?.Subcategory}</DialogContentText>
        <DialogContentText>Model: {initialData?.Model}</DialogContentText>
        <DialogContentText>Current Last Texture: {initialData?.lastTexture}</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          fullWidth
          variant="standard"
          inputRef={refLastTexture}
          id="text-field-last-texture"
          label="Last texture"
          type="number"
          defaultValue={initialData?.lastTexture}
          error={lastTextureError !== undefined}
          helperText={lastTextureError}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="error" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={okButtonClickHandler} disabled={loading}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
